<dpac-footer
  [appLogo]="appLogo()"
  [appLogo2x]="appLogo2x()"
  [appLogoLink]="appLogoLink()"
  [logoColLeft1]="logoColLeft1()"
  [logoColLeft2]="logoColLeft2()"
  [logoColLeft3]="logoColLeft3()"
  [logoColLeft4]="logoColLeft4()"
  [logoColRight]="logoColRight()"
  [logoColLeft1Link]="logoColLeft1Link()"
  [logoColLeft2Link]="logoColLeft2Link()"
  [logoColLeft3Link]="logoColLeft3Link()"
  [logoColLeft4Link]="logoColLeft4Link()"
  [logoColRightLink]="logoColRightLink()"
  [navLinks]="navItems()"
  [showBackToTop]="showBackToTop()"
  (actionClick)="handleFooterAction($event)"
></dpac-footer>
